module.exports = __webpack_public_path__ + "static/4BHK-04-Master-Bedroom-f34e4972dc7cb0cee3eb7b53ea211d0c.jpg";